import axios from "axios";
import config  from '../../config/environmentConfig';
import { brandConfig } from "../../brandConfig"
import { FormatInputPathObject } from "path";
export class Helpful {
    constructor() {}

    addReviewAsHelpful(): string {
        document.querySelectorAll('.kr-helpfulBtn .helpful').forEach(item => {
            item.addEventListener('click', (event) => {
                let reviewId = item.parentNode.parentElement.getAttribute('data-entity-id');
                let url  = encodeURI(config.url+'/review/'+brandConfig.brand+'/'+brandConfig.locale+'/'+reviewId+'/report/up');
                axios.post(url,{},{
                    headers: {
                        'x-api-key': brandConfig.apikey
                    },
                    validateStatus: function (status) {
                        return status >= 200 && status <= 400; // default; // Resolve only if the status code is less than 500
                    }
                }).then((response) => {
                    item.parentElement.classList.add('isInactive');
                    let thanksMessageElement =item.parentNode.parentElement.querySelector('.kr-thanksMessage'),
                        thanksMsgTextSelector = item.parentNode.parentElement.querySelector('.kr-thanks-text'),
                        socialElementSelector = item.parentNode.parentElement.querySelector('.kr-socialBtn');
                    thanksMessageElement.classList.add('show');
                    thanksMessageElement.classList.remove('kr-hide');
                    thanksMsgTextSelector.classList.add('show');
                    socialElementSelector.classList.add('kr-share-alignment-change');
                    if(window.ratingReview && window.ratingReview.events && window.ratingReview.events.rrHelpful) {
                        window.ratingReview.events.rrHelpful(item);
                    }
                    const rrHelpfulEvent = new Event('rrHelpful');
                    document.dispatchEvent(rrHelpfulEvent);
                }).catch((error) => {
                    console.error("error", error);
                })
            });
        });
        return ;
    }

    addReviewAsReported(): string {
        document.querySelectorAll('.kr-reportBtn .report-btn').forEach(item => {
            item.addEventListener('click', (event) => {
                let commentInput =  document.querySelector('#kr-reasonComment') as HTMLInputElement,
                    btnId = item.getAttribute('data-id'),
                    entityId = item.parentNode.parentElement.getAttribute('data-entityid'),
                    reason =  document.querySelector('.kr-reason') as HTMLInputElement,
                    reviewId = item.parentNode.parentElement.getAttribute('data-entity-id'),
                    popup = document.querySelector('.reportForm') as HTMLElement,
                    reviewElement = document.querySelector('.kr-reviewid') as HTMLInputElement,
                    entityElement = document.querySelector('.kr-entityid') as HTMLInputElement,
                    thanksMessageElement =document.querySelector('.kr-thanks-message-report'),
                    reasonSelectError = document.querySelector('#kr-reason-error') as HTMLElement,
                    commentError = document.querySelector('#kr-reason-comment-error') as HTMLElement,
                    closeSelector = document.querySelector('.closeReportButton') as HTMLElement,
                    cancelElement = document.querySelector('.kr-report-cancel') as HTMLElement,
                    formElement =document.querySelector('.report-form');
                if(!thanksMessageElement.classList.contains('.kr-hide')){
                    thanksMessageElement.classList.add('kr-hide')
                    formElement.classList.remove('kr-hide')
                }
                reason.value = ''
                commentInput.value = ''
                commentInput.classList.remove('error-focus');
                reasonSelectError.classList.add('kr-hide');
                commentError.classList.add('kr-hide')
                reviewElement.value = reviewId;
                entityElement.value = entityId;
                popup.classList.remove('kr-hide')
                popup.setAttribute('id',btnId)
                reason.focus();

                let handleListener = (event) =>{
                    if (event.key === 'Tab' && !event.shiftKey){
                        event.preventDefault();
                        (closeSelector as HTMLElement).focus();
                    }
                }

                let closeHandleListener = (event) =>{
                    if (event.shiftKey && event.key == 'Tab') {
                        event.preventDefault();
                        (cancelElement as HTMLElement).focus();
                    }
                }
                if(cancelElement) {
                    cancelElement.addEventListener('keydown', handleListener);
                }
                if(closeSelector) {
                    closeSelector.addEventListener('keydown', closeHandleListener);
                }
            });
        });
        document.querySelectorAll('.kr-reportBackButton').forEach(item => {
            item.addEventListener('click', (event) => {
                let popup = document.querySelector('.reportForm') as HTMLElement,
                    btnId = popup.getAttribute('id'),
                    btnToFocus = document.getElementsByClassName(btnId);
                popup.classList.add('kr-hide');
                (btnToFocus[0] as HTMLElement).focus()
            });
        });
        return ;
    }
    
    shareReviews(): string {
        document.querySelectorAll('.kr-socialBtn button').forEach(item => {
            item.addEventListener('click', (event) => {
                let reviewTitle = item.parentNode.parentElement.getAttribute('data-title');
                navigator.share({
                    url: window.location.href,
                    text: reviewTitle
                })
            });
        });
        return ;
    }
    onSubmitReport(): void {
        document.querySelectorAll('.reportForm .kr-report-submit').forEach(item => {
            item.addEventListener('click', (event) => {
                let reviewId = document.querySelector('.kr-reviewid') as HTMLInputElement,
                    reason =  document.querySelector('.kr-reason') as HTMLInputElement,
                    comment =  document.querySelector('#kr-reasonComment') as HTMLInputElement,
                    entityId = document.querySelector('.kr-entityid') as HTMLInputElement;
                    if (!reason.value) {
                        let reasonSelectError = document.querySelector('#kr-reason-error') as HTMLElement;
                        reasonSelectError.classList.remove('kr-hide')
                    } else if (reason.value === 'Other' && comment.value.trim() === '') {
                        let commentError = document.querySelector('#kr-reason-comment-error') as HTMLElement;
                        commentError.classList.remove('kr-hide')
                        comment.classList.add('error-focus')
                    }else{
                        let url  = encodeURI(config.url+'/review/'+brandConfig.brand+'/'+brandConfig.locale+'/'+reviewId.value+'/'+entityId.value+'/report/');
                        axios.post(url,{
                            "reason": reason.value,
                            "reasonComment": comment.value
                        },{
                            headers: {
                                'x-api-key': brandConfig.apikey
                            },
                            validateStatus: function (status) {
                                return status >= 200 && status <= 400; // default; // Resolve only if the status code is less than 500
                            }
                        }).then((response) => {
                            let thanksMessageElement =document.querySelector('.kr-thanks-message-report'),
                                returnButton = document.querySelector('.kr-close-button-report') as HTMLElement,
                                closeSelector = document.querySelector('.closeReportButton') as HTMLElement;
                            
                            let formElement =document.querySelector('.report-form');
                            thanksMessageElement.classList.remove('kr-hide');
                            formElement.classList.add('kr-hide');
                            thanksMessageElement.classList.remove('kr-hide');
                            returnButton.focus()


                            let handleListener = (event) =>{
                                if (event.key === 'Tab'){
                                    event.preventDefault();
                                    (closeSelector as HTMLElement).focus();
                                }

                            }
                            if(returnButton) {
                                returnButton.addEventListener('keydown', handleListener);
                            }
                        }).catch((error) => {
                            console.error("error", error);
                        })
                    }
            });
        })
    }

    updateReviewCommentMessage(): void{
        let commentInput = (document.querySelector('#kr-reasonComment') as HTMLInputElement),
            commentError = document.querySelector('#kr-reason-comment-error') as HTMLElement;
        if (commentInput) {
            commentInput.addEventListener('keyup', ()=>{
                if(commentInput.value.length > 1){
                    commentInput.classList.remove("error-focus")
                    commentError.classList.add('kr-hide')
                }
            });
        }
    }
    onReasonChange():void {
        let dropdownReasonSelect: HTMLSelectElement = <HTMLSelectElement>document.querySelector(".kr-reason"),
            commentInput =  document.querySelector('#kr-reasonComment') as HTMLInputElement,
            reasonSelectError = document.querySelector('#kr-reason-error') as HTMLElement,
            commentError = document.querySelector('#kr-reason-comment-error') as HTMLElement;
        if (dropdownReasonSelect) {
            let reasonCb = async () => {
                let selectIndex = dropdownReasonSelect.options.selectedIndex;
                if (dropdownReasonSelect.options[selectIndex].value === ""){
                    reasonSelectError.classList.remove('kr-hide');
                    commentInput.classList.remove('error-focus');
                    commentError.classList.add('kr-hide');
                }else{
                    reasonSelectError.classList.add('kr-hide')
                }
                document.querySelector(".kr-reason option[selected]").removeAttribute('selected');
                dropdownReasonSelect.options[selectIndex].setAttribute('selected', 'true');
                // this.updatePageNav(this, filterReviewCount);
            };
            dropdownReasonSelect.onchange = reasonCb;
        }
    }
    openDeskShareReview(): string {
        function _trackSocialShare(socialService, pageTitle) {
            let compName = "socialSharing",
            evDetails= {};
                
            evDetails['eventInfo'] = {
                'type': window?.ctConstants?.trackEvent || '',
                'eventAction': window?.ctConstants?.share || '',
                'eventLabel': compName + ' - ' + socialService + ' - ' + pageTitle,
                'eventValue': 1
            };
            evDetails["category"] = {
                'primaryCategory': window?.ctConstants?.advocacy || ''
            };
            evDetails["subcategory"] = 'Lead';
            return evDetails;
        };
        document.querySelectorAll('.kr-socialBtn button').forEach(item => {
            let handleListener = ()=>{
                    if(item.querySelector('.kr-share').classList.contains('kr-show')) {
                        item.querySelector('.kr-share').classList.remove('kr-show');
                        item.setAttribute('aria-expanded', 'false');
                    } else {
                        item.querySelector('.kr-share').classList.add('kr-show');
                        item.setAttribute('aria-expanded', 'true');
                    }
            }

            let handleIconListener = (event)=>{
                console.log('inside handleIconListener')
                if (event.key === 'Tab' && !event.shiftKey) {
                    if(item.querySelector('.kr-share').classList.contains('kr-show')) {
                        item.querySelector('.kr-share').classList.remove('kr-show');
                        item.setAttribute('aria-expanded', 'false');
                    } else {
                        item.querySelector('.kr-share').classList.add('kr-show');
                        item.setAttribute('aria-expanded', 'true');
                    }
                }
            }
            let socialShareElements = item.querySelectorAll('[class$="share-button"]');
            
            if(socialShareElements.length > 0){
                let pgTitle = document.querySelector('.c-social-sharing-component') ?  document.querySelector('.c-social-sharing-component').getAttribute('addthis:title'): "";
                let pdDes = document.querySelector('.c-social-sharing-component') ? document.querySelector('.c-social-sharing-component').getAttribute('addthis:description') : "";
                let pageTitle = (pgTitle !== '' && pgTitle !== null) ? pgTitle : 
                                (pdDes !== '' && pdDes !== null) ? pdDes : document.title ;
                socialShareElements.forEach(_shareEl => {
                    let socialService = _shareEl.getAttribute('title') || '';
                    _shareEl.addEventListener('click',(event)=>{
                        let trackShare = _trackSocialShare(socialService, pageTitle);

                        //Todo - remove when Kritique analytics is created
                        const rrSocialShareEvent = new CustomEvent("rrSocialShare", {
                            'detail': trackShare
                          });
                        document.dispatchEvent(rrSocialShareEvent);
                        if(window.digitalData !== undefined) window.digitalData.event.push(trackShare);
                    })
                })
            }
            item.querySelector('.kr-share a:last-child').addEventListener('keydown',(event)=> {
                handleIconListener(event);
            })
            item.addEventListener('click', (event) => {
                handleListener();
            });
        });
        
        return ;
    }
}